"use client";

import React from "react";

export interface IconProps extends React.SVGProps<SVGSVGElement> {}

/**
 * The `<svg>` wrapper behind icons made with `createIcon`: decorative by default
 * (`aria-hidden`, not focusable). Size it with `className` (default `size-16`).
 */
export const Icon = React.forwardRef<SVGSVGElement, IconProps>(
  function Icon(props, ref) {
    return (
      <svg
        ref={ref}
        focusable={false}
        aria-hidden="true"
        className={"size-16"}
        {...props}
      />
    );
  }
);
